// auth/auth.guard.ts
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { CanActivateFn } from '@angular/router';

export const authGuard: CanActivateFn = () => {
  const oauthService = inject(OAuthService);

  if (oauthService.hasValidAccessToken()) {
    return true;
  }

  oauthService.initLoginFlow();
  return false;
};
